import tableRowRules from '../../table/row-line';

const light = (params) => tableRowRules.light(params);

export default light;
